/**
 *  This function takes an object of props and uses to conditionally
 *  apply certain classes based on what props it receives. This is a more
 *  declarative way to apply conditional classes to components based on what
 *  props they receive because it defines strict states the component can
 *  exist in
 *
 *  @param args -- An object of props in the form of
 *      { propName: propValue } -> { size: 's' }
 *
 *  @param classMap -- an object that relates a prop value to a class
 *      { propValue: correspondingClass } -> { s: 'o-button--s' }
 */

export default function generateClassesFromMap(args, classMap) {
  return Object.keys(args).reduce((acc, curr) => {
    if (args[curr]) {
      // eslint-disable-next-line no-param-reassign
      acc += ` ${classMap[curr][args[curr]]}`
    }
    return acc
  }, '')
}
